// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1RCcQ","title":"AfterFrontImage_title__2tW31"};